import dayjs from 'dayjs';

export const INITIAL_SEARCH_PARAMS = {
    startDate: dayjs().subtract(1, 'month'),
    endDate: dayjs(),
    subOrderId: '',
    vendorId: '',
    managerId: '',
    itemId: '',
    deliveryId: '',
    dyeNo: '',
    dateBasis: 'planned_dispatch_at'
};

export const INITIAL_ALERT_INFO = {
    open: false,
    title: '',
    message: '',
    severity: 'info',
    onConfirm: null,
    onClose: null
};

export const getBasicColumns = (t) => [
    { id: 'no', label: t('invoice.columns.no'), minWidth: 50 },
    { id: 'customer', label: t('invoice.columns.customer'), minWidth: 150 },
    { id: 'subOrderId', label: t('invoice.columns.subOrderId'), minWidth: 120 },
    { id: 'buyer', label: t('invoice.columns.buyer'), minWidth: 120, defaultHidden: true },
    { id: 'style', label: t('invoice.columns.style'), minWidth: 120 },
    { id: 'file', label: t('invoice.columns.file'), minWidth: 100 },
    { id: 'manager', label: t('invoice.columns.manager'), minWidth: 120, defaultHidden: true },
    { id: 'dyeingNo', label: t('invoice.columns.dyeingNo'), minWidth: 120 },
    { id: 'delivery', label: t('invoice.columns.delivery'), minWidth: 120 },
    { id: 'item', label: t('invoice.columns.item'), minWidth: 150 },
    { id: 'size', label: t('invoice.columns.size'), minWidth: 90 },
    { id: 'color', label: t('invoice.columns.color'), minWidth: 100 },
    { id: 'price', label: t('invoice.columns.price'), minWidth: 100 },
    { id: 'orderQty', label: t('invoice.columns.orderQty'), minWidth: 100 },
    { id: 'currency', label: t('invoice.columns.currency'), minWidth: 80, defaultHidden: true },
    { id: 'giReqNo', label: t('invoice.columns.giReqNo'), minWidth: 100 },
    { id: 'giReqLineId', label: t('invoice.columns.giReqLineId'), minWidth: 120, defaultHidden: true },
    { id: 'giReq', label: t('invoice.columns.giReq'), minWidth: 130 },
    { id: 'packing', label: t('invoice.columns.packing'), minWidth: 140 },
    { id: 'giPost', label: t('invoice.columns.giPost'), minWidth: 100 },
    { id: 'priceSum', label: t('invoice.columns.priceSum'), minWidth: 120 },
    { id: 'invoiceNo', label: t('invoice.columns.invoiceNoCol'), minWidth: 120 },
    { id: 'sign', label: t('invoice.columns.sign'), meta: true }
];
